import { render, staticRenderFns } from "./config.vue?vue&type=template&id=0ab4a7a8&"
import script from "./config.vue?vue&type=script&lang=ts&"
export * from "./config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports